<div class="thumbnail">
  <img [src]="imageUrl" alt="Thumbnail" (click)="showFullImage()" />
</div>

<div #fullImage>
    <div class="full-image" *ngIf="isFullImage" (click)="closeImage()">
        <img [src]="imageUrl" alt="Full Image" />
    </div>
</div>
